<template>
  <div>
    <profile-app-bar />

    <v-dialog v-model="showDialog" width="400">
      <v-card class="pa-4">
        <v-card-text>I have answered all the questions to the best of my ability and acknowledge that the information I have entered is true and valid.</v-card-text>
        <v-card-actions>
          <v-container class="d-flex align-center justify-center" fluid>
            <v-btn color="accent" @click="updateEligibility">I Agree</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="px-12 mt-12 align-center" fill-height>
      <header-title
        class="mb-2 align-self-start mt-12"
        title="Eligibility Requirement Check List"
        subtitle="be eligible candidates must meet the following criteria"
      />
      <v-row>
        <v-col cols="12" sm="12" lg="6" md="6" v-for="(item,i) in items" :key="i">
          <v-card>
            <v-card-text class="d-flex">
              <v-checkbox v-model="item.checked" class="pa-0 ma-0" />
              <span class="mb-1">{{ item.text }}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="4">
          <v-btn
            :disabled="!isAllChecked"
            :loading="loading"
            @click="onNext"
            :width="150"
            color="accent"
          >Next</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import HeaderTitle from "../components/HeaderTitle";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import ProfileAppBar from "../components/ProfileAppBar";

export default {
  name: "EligibilityScreen",
  components: {
    HeaderTitle,
    ProfileAppBar
  },

  created() {
  },

  data() {
    return {
      showDialog: false,
      loading: false,
      items: [
        {
          text: "Be between the ages of 24-35 by May 3rd 2021.",
          checked: false
        },
        {
          text:
            "Having completed or being currently enrolled in a PhD, MSc, LLM, MPP or MBA program at an African University.",
          checked: false
        },
        {
          text: "Be a citizen of an African nation.",
          checked: false
        },
        {
          text:
            "Be elegible for international travel to Italy, if you gain access to the second residential module.",
          checked: false
        },
        {
          text:
            "Resident of an African nation or planning to relocate by the end of 2020.",
          checked: false
        },
        {
          text: "Be fully fluent and proficient in the English Language.2020.",
          checked: false
        },
        {
          text:
            "BA Degree in Engineering, Computer Science, Law or Business from an African University",
          checked: false
        },
        {
          text:
            "Demonstrated interest in the electricity sector in the African Continent.",
          checked: false
        }
      ]
    };
  },

  computed: {

    ...mapFields("profile", [
      "profile", 
      "profile.isEligible"
    ]),

    isAllChecked() {
      const uncheckedItems = this.items.filter(item => {
        return item.checked === false;
      });

      // if we don't have unchecked items it means
      // that all the items has been checked by the user
      // and we can continue
      return uncheckedItems.length === 0;
    }
  },
  methods: {
    ...mapActions("profile", ["saveEligibilityChecked"]),
    ...mapActions("profile", ["setProfile"]),

    onNext() {
      this.showDialog = true;
    },
    async updateEligibility() {
      this.showDialog = false;

      this.loading = true;

      try {
        // update that user is eligible
        await this.saveEligibilityChecked(this.profile._id);
        // set that applicant is eligible
        this.isEligible = true;

        this.setProfile(this.profile);


        // replace to show the next page
        // we use replace because the user don't need to
        // go back to this page again after accept it
        this.$router.replace({
          name: "home"
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>